import underscoreQuery from 'underscore-query/lib/underscore-query'
underscoreQuery(window._)
